/* Stylesheet */

.chart_label {
  display: flex;
  align-items: center;
  color: var(--ion-color-text-tertiary);

  .icon {
    height: 28px;
    width: 28px;
  }

  .total_container {
    margin: 0px 42px 0px 12px;
    text-align: center;

    .label {
      margin: 0px 0px 6px 0px;
      font-size: 1rem;
    }

    .total {
      font-size: 1.313rem;
      font-weight: 700;
    }

    .overall {
      font-size: 0.75rem;
    }

    .completeness {
      font-size: 0.75rem;
      white-space: nowrap;
    }
  }

  .label {
    font-size: 1rem;
  }

  .feature_or_cohort {
    font-size: 1rem;
    font-weight: 500;
  }
}
